import { useState } from "react";
import { IdUploadApi } from "../api/Api";

export const useIdUpload = () => {
  const [isLoading, setIsLoading] = useState(false);
  const saveIdUpload = async (
    upload_data,
    visitor_parameters,
    form_data,
    data,
    query_string,
    message_type
  ) => {
    const response = await IdUploadApi.post("api/v1/data-ingestion-pipeline", {
      upload_data,
      visitor_parameters,
      form_data,
      data,
      query_string,
      message_type,
    });
    setIsLoading(false);
    return response;
  };
  return {
    isLoading,
    saveIdUpload,
  };
};
